import React from 'react';
// import { useNavigate } from 'react-router-dom';
import footerLogo from '../assets/intematics-footer-logo.png';
import MDLogo from '../assets/md-logo.png';
// import LinkedIn from '../assets/linkedin.png';
// import phone from '../assets/fon.png';
// import location from '../assets/lokasi.png';
// import email from '../assets/sampul.png';

// This is the fixed version of the Footer component
// ESLint warning fixed by replacing <a> tags with <button> elements for navigation

const Footer = () => {
  // const navigate = useNavigate();
  // const handleNavigate = (path) => {
  //   navigate(path);
  //   window.scrollTo(0, 0);
  // };

  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-columns">
          <div className="footer-column">
            <div className="footer-logo">
              <img src={footerLogo} alt="Intematics" />
              <p>Intematics Sdn Bhd © 202201035847 (1481544-X)</p>
              {/* <p>Intematics was born from a vision to redefine how we live and work — empowering people everywhere with better, smarter workspaces.</p> */}
            </div>
          </div>
          
          <div className="footer-column">
            {/* <h4>Information</h4> */}
            <ul>
              {/* <li><button className="footer-link-Company" onClick={() => handleNavigate('/home')}>Company</button></li>
              <li><button className="footer-link-Contact-Us" onClick={() => handleNavigate('/contact')}>Contact Us</button></li>
              <li><button className="footer-link-ThinkAI" onClick={() => handleNavigate('/thinkfinance')}>Products</button></li>
              <li><button className="footer-link-TAAS" onClick={() => handleNavigate('/taas')}>TAAS</button></li>
              <li><button className="footer-link-MARS" onClick={() => handleNavigate('/marketresearch')}>MARS</button></li>
              <li><button className="footer-link-ThinkAI-Portal" onClick={() => handleNavigate('/thinkai')}>ThinkAI Portal</button></li> */}
            </ul>
          </div>
         
          <div className="footer-column">
            {/* <h4>Contact</h4> */}
            <address>
              {/* <p>1-3-21 Krystal Point Corporate Park, 11900 Bayan Lepas, Pulau Pinang</p>
              <p><a href="tel:+6012-4072618">+60 12-407 2618</a></p>
              <p><a href="mailto:enquiry@intematics.com">enquiry@intematics.com</a></p> */}
              <div className="icon-container">
                {/* <img src={location} alt="Location" className="location-custom-icon" />
                <img src={phone} alt="Phone" className="phone-custom-icon" />
                <img src={email} alt="Email" className="email-custom-icon" /> */}
              </div>
            </address>
          </div>
          
          <div className="footer-column">
            {/* <h4>Social Media</h4> */}
            {/* <div className="social-icons">
              <a href="https://linkedin.com/company/intematics" target="_blank" rel="noopener noreferrer" className="social-icon">
                <img src={LinkedIn} alt="LinkedIn" className="linkedin-custom-icon" />
              </a>
            </div> */}
            <div className="md-logo">
              <img src={MDLogo} alt="Malaysia Digital" />
              <p>Recognised by MDEC</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;